<template>
    <div>
        <vueHeader :navNum="2"></vueHeader>

        <div class="banner">
            <img src="./../assets/img/health/banner.jpg" alt="">
        </div>

        <div class="about">
            <div class="left">
                <p class="title">关于我们</p>
                <p class="txt">我们最为极致的精华是全球最为领先并独一无二的抗衰老疗法--胸腺肽细胞疗法。细胞疗法是一个广义的术语，指将正常或生物工程改造过的人体细胞移植或输入患者体内，新输入的细胞可以替代受损细胞、或者具有更强的免疫杀伤功能，从而达到治疗疾病的目的。胸腺肽（又名胸腺素 、Thymosin）是胸腺组织分泌的具有生理活性的一组多肽，激发免疫系统、产生白血球、抵抗所有免疫功能低下等。现胸腺肽细胞疗法广泛应用于临床各类疾病的治疗，主要包括血液类疾病、器官移植、心血管系统疾病、肝脏疾病、神经系统疾病、组织创伤等方面。疗法会产生长期效果。在接受治疗几周后总体健康情况即有所改善。疗法的最重要的特点是对免疫系统可能产生长期改善。一旦防御细胞功能恢复,就不会再发生功能障碍。以此，使我们的用户向健康生活迈进一大步。</p>
                <p class="txt">我们拥有全球领先的医学院资源和独立实验室。产品通过德国严格而苛刻的食物与药物标准，在欧洲和北美国家已经可以上市销售。但稀有定制化的抗衰老产品无法规模生产以满足市场的需求，因此我们仅为尊贵而有限的会员提供。在此，我们可以自豪地告诉每一位尊贵的会员，目前最为顶尖著名的抗衰老疗法中心也在向我们购买我们独有的抗衰老产品。我们汇集了我们能做到的最为极致之精华，希望能为您提供完全不同的人生之旅。</p>
            </div>
            <div class="right">
                <img src="./../assets/img/health/about.png" />
                <div class="bg"></div>
            </div>
        </div>

        <div class="news">
            <div class="title">
                新闻资讯
                <router-link to="/healthList">
                    <div class="more">more</div>
                </router-link>
            </div>
            <swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if="news.length">
                <!-- slides -->
                <swiper-slide v-for="(item,index) in news.slice(0,9)" :key="index">
                    <div class="item" @click="goArtical(item.id)">
                        <div class="news_img">
                            <img :src="item.cover" />
                            <div class="desc">{{item.txt}}</div>
                        </div>
                        <div class="bottom">
                            <p class="headline">{{item.title}}</p>
                            <p class="time">{{item.month}}-{{item.day}}</p>
                            <p class="txt">{{item.desc.substring(0,110)}}...</p>
                        </div>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="point" slot="pagination"></div>
            </swiper>
        </div>

        <div class="consult">
            <div class="comment">
                <p class="headline">留言与咨询</p>
                <p class="eng">Message and consultation</p>
                <div class="line"></div>
                <div class="illustrate">
                    <p class="txt">如果您有意向在LOTO做抗衰老疗法，请您提前和我们做好预约和行程安排；如果您想通过我们来一次特别的旅行和生活体验，我们同样欢迎您的加入。</p>
                    <p class="txt">如果您还需要卢森堡大公国的税务和财务咨询，也请您留下您的咨询信息。</p>
                    <p class="txt">以上每一项，我们都可以提供对应的业界最高职业素养的人为您提供我们能做到的最为极致服务。</p>
                </div>
                <div class="info">
                    <input type="text" v-model.trim="name" placeholder="姓名" />
                    <input type="text" v-model.trim="phone" placeholder="邮箱" />
                    <textarea v-model.trim="consult" placeholder="留下您想咨询或感兴趣的问题，我们将会派专人联系您"></textarea>
                    <div class="btn" @click="submit()">确认提交</div>
                </div>
            </div>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            introduce: [
                {
                    img: require('./../assets/img/health/icon1.png'),
                    title: '美食',
                    txt: '我们提供的米其林三星餐厅让您开启一段奇妙的感官体验之旅，高水准的前卫美食，是一场真正的美食之旅。'
                },
                {
                    img: require('./../assets/img/health/icon2.png'),
                    title: '住宿',
                    txt: '我们提供的五星级度假酒店为您奉献豪华、惬意的尊崇享受,让您拥有无与伦比的入住体验，更安心的享受旅途。'
                },
                {
                    img: require('./../assets/img/health/icon3.png'),
                    title: '出行',
                    txt: '我们提供劳斯莱斯或奔驰AMG等一系列的专车。同时为您配置业界最高素质的职业司机，让您免去旅途的驾驶疲惫。'
                },
                {
                    img: require('./../assets/img/health/icon4.png'),
                    title: '服务',
                    txt: '我们提供专业的翻译和陪同人员，帮助您更好更快地制定旅行路线，让您的旅行更简单更从容，行程随时调整，让您的旅行更高效更特色。'
                },
            ],
            news: [],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 0,
                slidesPerGroup: 3,
                loop: true, //循环
                initialSlide: 0, //设定初始化时slide的索引
                //autoplay: false, //自动播放
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                speed: 1200, //滑动速度
                direction: "horizontal", //滑动方向
                // grabCursor : true, //小手掌抓取滑动
                on: {
                },
                pagination: {
                    //分页器设置
                    el: ".point",
                    clickable: true
                }
            },
            name: '',
            phone: '',
            consult: ''
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        this.news = this.$store.state.healthArtical;
    },

    methods: {
        goArtical(id) {
            this.$store.commit('changehealthArticalId', id);
            this.$router.push({ path: '/healthContent' });
        },
        submit() {
            let _this = this;
            if (this.name == '') {
                this.$kiko_message({
                    message: '请输入姓名',
                    time: 1000
                });
            } else if (this.phone == '') {
                this.$kiko_message({
                    message: '请输入邮箱',
                    time: 1000
                });
            } else if (this.consult == '') {
                this.$kiko_message({
                    message: '请输入您想咨询或感兴趣的问题',
                    time: 1000
                });
            } else {
                $.ajax({
                    url: 'http://116.62.23.229:8090/leaveMassage/messageAddLoto',
                    type: 'post',
                    data: {
                        name: _this.name,
                        email: _this.phone,
                        content: _this.consult
                    },
                    success(data) {
                        console.log(data);
                        if (data.success) {
                            _this.$kiko_message({
                                message: '提交成功',
                                time: 1000
                            });
                            _this.name = '';
                            _this.phone = '';
                            _this.consult = '';
                        } else {
                            _this.$kiko_message({
                                message: data.msg,
                                time: 1000
                            });
                        }
                    }
                })
            }
        }
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/health.less";
</style>


// WEBPACK FOOTER //
// src/views/health.vue